import { useContext } from "react"
import { TextoImpressaoContext } from "./TextoImpressaoContext"

export function useTextoImpressaoContext() {
    return useContext(TextoImpressaoContext)
}
